import api from "../apiConfig";
import paramsFactory from "../../utils/paramsFactory";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/tasks?${p}`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },
  categories(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/tasks/categories?${p}`);
  },
  showById(id) {
    return api.get(`/api/v1/tasks/${id}`);
  },
  create(data) {
    return api.post(`/api/v1/tasks`, data);
  },
  update(id, data) {
    return api.put(`/api/v1/tasks/${id}`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/tasks/${id}`);
  },
  addAssignees(id, data) {
    return api.post(`/api/v1/tasks/${id}/assignees`, data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },
  removeAssignees(id, data) {
    return api.post(`/api/v1/tasks/${id}/assignees/remove`, data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },
  close(id) {
    return api.post(`/api/v1/tasks/${id}/close`);
  },
  addComment(id, data) {
    return api.post(`/api/v1/tasks/${id}/comments`, data);
  },
};
